<template>
  <div class="pt-5">
    <v-data-table
      :items="emisiones"
      :headers="headers"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :page="page"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
      :server-items-length="totalItems"
      no-data-text="Sin emisiones para mostrar"
      no-results-text="Sin resultados para mostrar"
      loading-text="Cargando..."
      :footer-props="{
        'items-per-page-all-text': 'Todos',
        'items-per-page-text': 'Elementos por página',
      }"
    >
      <template v-slot:top>
        <v-row style="padding: 15px;">
          <v-col cols="12" md="8">
            <h2>Resultados</h2>
          </v-col>
          <!-- <v-col cols="12" md="4" style="text-align: end;">
            <download-csv :data="columnsReport" name="polizas_tabla.csv">
              <v-btn color="transparent" elevation="0" small>
                <span style="color:#0070C0;">Descargar</span>
                <v-icon small right class="mr-2" color="#0070C0"
                  >mdi-file-pdf-box</v-icon
                >
              </v-btn>
            </download-csv>
          </v-col> -->
        </v-row>
      </template>

      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        <div v-if="itemsLength">
          Mostrando {{ pageStart }} - {{ pageStop }} de
          {{ itemsLength }} solicitudes
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    emisiones: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    totalItems: Number,
    page: Number,
    itemsPerPage: Number,
  },

  data() {
    return {
      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Certificado",
          value: "certificado",
        },
        {
          text: "Fecha",
          value: "fechaEmision",
        },
        {
          text: "Teléfono Contacto",
          value: "telefonoContacto",
        },
      ],
      columnsReport: [],
    };
  },

  methods: {
    onPageChange(newPage) {
      this.$emit("pageChanged", newPage);
    },
    onItemsPerPageChange(newItemsPerPage) {
      this.$emit("itemsPerPageChanged", newItemsPerPage);
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}
</style>
